import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {Tab, Tabs} from "@mui/material";

import Badge from "components/Badge";
import {black400, black500, blue500, grey300, greyishBlue100, greyishBlue500} from "assets/jss/main";

import {ENRICHMENT_TAB_ORDER} from "../enrichmentConstants";

TypeTabs.propTypes = {
    value: PropTypes.oneOf(ENRICHMENT_TAB_ORDER).isRequired,
    counts: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

const tabsSx = {
    minHeight: '40px',
    borderBottom: `1px solid ${greyishBlue100}`,
    '& .MuiTabs-flexContainer': {
        gap: '32px',
    },
    '& .MuiTabs-indicator': {
        height: '2px',
        backgroundColor: blue500,
        borderRadius: '8px 8px 0 0',
    },
};

const tabSx = {
    minHeight: '32px',
    height: '32px',
    margin: '0 0 8px',
    padding: '6px 12px',
    gap: '8px',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: 400,
    color: greyishBlue500,
    '&.Mui-selected': {
        color: black500,
        fontWeight: 600,
    },
    '& .MuiTab-iconWrapper': {
        margin: 0,
    },
};

function TypeTabs({value, counts, onChange}) {
    return (
        <Tabs value={value} onChange={(event, tab) => onChange(tab)} variant="scrollable" scrollButtons={false} sx={tabsSx}>
            {ENRICHMENT_TAB_ORDER.map((tab) => (
                <Tab
                    key={tab}
                    value={tab}
                    disableRipple
                    sx={tabSx}
                    iconPosition="end"
                    icon={<Badge backgroundColor={grey300} labelColor={black400}>{counts[tab] ?? 0}</Badge>}
                    label={<FormattedMessage id={`enrichment.tab.${tab}`}/>}
                />
            ))}
        </Tabs>
    );
}

export default TypeTabs;
